module.exports = __webpack_public_path__ + "img/branch.a6b0d4b6.png";